<template>
  <nav>
    <v-img
      :src="require('../assets/' + pageImage + '.png')"
      width="100%"
      max-width="400px"
      class="mx-auto mb-10"
    />
    <p class="text-h5 font-weight-bold">
      {{ pageTitle }}
    </p>
    <!-- eslint-disable vue/no-v-html -->
    <p
      class="text-body-1"
      v-html="pageText"
    />
  </nav>
</template>
<script>
export default {
  props: {
    pageTitle: {
      type: String,
      default: ''
    },
    pageText: {
      type: String,
      default: ''
    },
    pageImage: {
        type: String,
        default: 'empty_page'
    },
  },
}
</script>